import React, { useEffect, useState } from 'react';
import { RefreshCw, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePWA } from '@/hooks/usePWA';
import { updateDeferral } from '@/lib/pwa/updateLifecycle';

export const UpdateNotification: React.FC = () => {
  const { canUpdate, update } = usePWA();
  const [isVisible, setIsVisible] = useState(false);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    if (!canUpdate) {
      setIsVisible(false);
      return;
    }
    // Si el usuario la pospuso, no volver a molestar durante 24 h.
    if (updateDeferral.isDeferred()) {
      setIsVisible(false);
      return;
    }
    setIsVisible(true);
  }, [canUpdate]);

  const handleUpdate = () => {
    setUpdating(true);
    update();
  };

  const handleDismiss = () => {
    updateDeferral.defer();
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed top-[calc(1rem+env(safe-area-inset-top))] left-1/2 -translate-x-1/2 z-50 animate-slide-up max-w-[calc(100%-1.5rem)]">
      <div className="bg-primary text-primary-foreground rounded-xl p-4 shadow-elegant border border-primary/20 flex items-center gap-3">
        <RefreshCw className={`w-5 h-5 ${updating ? 'animate-spin' : ''}`} />
        <div>
          <p className="font-medium text-sm">Nueva versión disponible</p>
          <p className="text-xs opacity-90">
            {updating ? 'Aplicando la actualización…' : 'Actualiza para ver los cambios'}
          </p>
        </div>
        <Button
          onClick={handleUpdate}
          size="sm"
          variant="secondary"
          className="ml-2"
          disabled={updating}
        >
          {updating ? 'Actualizando…' : 'Actualizar'}
        </Button>
        <Button
          onClick={handleDismiss}
          size="sm"
          variant="ghost"
          aria-label="Ahora no"
          title="Ahora no"
          disabled={updating}
          className="px-2 text-primary-foreground hover:bg-primary-foreground/10"
        >
          <X className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};
